module.exports = __webpack_public_path__ + "static/media/Group94.618da673.png";